// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"121ebc98","977":"5a47d40e"}[chunkId] + ".chunk.js";
};